import React from 'react';
import { BUSINESS } from '../../config/businessInfo';

/**
 * Satıcı / vergi bilgisi özeti (footer, sözleşmeler).
 */
const BusinessLegalSummary = ({ className = '', compact = false }) => {
  if (compact) {
    return (
      <p className={`text-sm leading-relaxed ${className}`}>
        <strong>{BUSINESS.brandName}</strong> ({BUSINESS.storeType}) · Vergi No: {BUSINESS.taxNumber} ·{' '}
        {BUSINESS.taxOffice}
        <br />
        {BUSINESS.address}
        <br />
        {BUSINESS.emailInfo} · {BUSINESS.emailContact} · {BUSINESS.phone}
      </p>
    );
  }

  return (
    <div className={`space-y-2 text-sm ${className}`}>
      <p>
        <strong>Ünvan / Marka:</strong> {BUSINESS.brandName} ({BUSINESS.storeType})
      </p>
      <p>
        <strong>Vergi No:</strong> {BUSINESS.taxNumber}
      </p>
      <p>
        <strong>Vergi Dairesi:</strong> {BUSINESS.taxOffice}
      </p>
      <p>
        <strong>Vergi levhası adresi:</strong> {BUSINESS.address}
      </p>
      <p>
        <strong>E-posta:</strong> {BUSINESS.emailInfo}, {BUSINESS.emailContact}
      </p>
      <p>
        <strong>Telefon:</strong> {BUSINESS.phone}
      </p>
      <p>
        <strong>Web:</strong> {BUSINESS.websiteDisplay}
      </p>
    </div>
  );
};

export default BusinessLegalSummary;
